import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ValidationErrorComponent } from '@app/shared/components/validation-error/validation-error.component';
import { FormFieldComponent } from './form-field.component';

/** The help text under a field, replaced by the validation errors while the field shows them. */
@Component({
  selector: 'c-field-message',
  templateUrl: './field-message.component.html',
  styleUrl: './field-message.component.scss',
  imports: [ValidationErrorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldMessageComponent {
  protected readonly field = inject(FormFieldComponent);

  readonly helpText = input<string>();
}
